export default "__VITE_ASSET__bIHPIv2V__"